import React, { useState, useEffect } from "react";
import { FaUserNinja } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import API_URL from "../config";
import Loading from "../components/Loading";
import { useAdmin } from "../contexts/AdminContext";

const TrainerManagement = () => {
  const { admin } = useAdmin();
  const navigate = useNavigate();
  const [trainers, setTrainer] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTrainers = async () => {
    try {
      const response = await fetch(
        `${API_URL}/trainer/branch/${admin?.branch}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch trainers");
      }
      const data = await response.json();
      const sortedUsers = data.sort((a, b) => {
        return parseInt(a.trainerId) - parseInt(b.trainerId);
      });

      setTrainer(sortedUsers);
    } catch (error) {
      console.error("Error fetching trainers:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrainers();
  }, []);

  const handleDelete = async (trainerId) => {
    try {
      const response = await fetch(`${API_URL}/trainer/${trainerId}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw new Error("Failed to delete trainer.");
      }

      const data = await response.json();
      alert("Trainer deleted successfully!");
      fetchTrainers();
    } catch (error) {
      console.error("An error occurred while deleting the trainer.");
    }
  };

  const handleViewUsers = (trainerId) => {
    navigate(`/admin/trainermanagement/${trainerId}`);
  };

  return (
    <div className="userManagementContainer">
      <div className="userManagementHeader">
        <div className="userHeaderLeft">
          <FaUserNinja size={30} color="#ff0000" style={{ marginRight: 10 }} />
          <h2>Trainer Management</h2>
        </div>

        <div
          className="addUserBtn"
          onClick={() => navigate("/admin/trainermanagement/addtrainer")}
        >
          <FaUserNinja />
          <p>Add New Trainer</p>
        </div>
      </div>
      <h3>Trainer Information</h3>
      <div className="table-container">
        {loading ? (
          <Loading />
        ) : (
          <table className="custom-table">
            <thead>
              <tr>
                <th>Trainer ID</th>
                <th>Trainer Name</th>
                <th>Username</th>
                <th>Phone Number</th>
                <th>Gender</th>
                <th>Age</th>
                <th>Address</th>
                <th>View Users</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {trainers.map((trainer) => (
                <tr key={trainer.trainerId}>
                  <td>{trainer.trainerId}</td>
                  <td>{trainer.name}</td>
                  <td>{trainer.username}</td>
                  <td>{trainer.phone}</td>
                  <td>{trainer.gender}</td>
                  <td>{trainer.age}</td>
                  <td>{trainer.address}</td>
                  <td className="trainerManageUserBtn">
                    <button onClick={() => handleViewUsers(trainer.name)}>
                      View Users
                    </button>
                  </td>
                  <td
                    className="deleteBtnGymTable"
                    onClick={() => handleDelete(trainer.trainerId)}
                  >
                    <RiDeleteBin6Line style={{ cursor: "pointer" }} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default TrainerManagement;
